export default __webpack_public_path__ + "105e924d4ea02eeb26f0157945b74417.svg";